import module from 'fanconsultores/module.js'

function FanSharedLanguageLoaderFactory ($http, $q) {
  return (options) => {
    return $q((resolve, reject) => {
      $http.get(`/i18/${options.key}.json`)
        .then((response) => (resolve(response.data)))
        .catch(() => (reject(options.key)))
    })
  }
}

module.factory('FanSharedLanguageLoader', FanSharedLanguageLoaderFactory)



// WEBPACK FOOTER //
// ./src/fanconsultores/services/Shared/Language/Loader.js